import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';

@Component({
    selector: 'memo-dialog',
    templateUrl: './memo-dialog.component.html',
    styleUrls: ['./memo-dialog.component.scss']
})
export class MemoDialogComponent implements OnInit {
    public memo: string;
    private originalMemoNote: string = '';
    public mobile: boolean = false;

    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<MemoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
    ) { }

    ngOnInit() {
        this.memo = this.data.dialogData.memo;
        this.originalMemoNote = this.data.dialogData.memo;
        this.mobile = this.data.dialogData.mobile;

        if (this.mobile) {
            const dialogAction = this.data.actionClicked as Observable<void>;

            dialogAction.subscribe(() => {
                this.save();
            });
        }
    }

    save() {
        this.dialogRef.close(this.memo);
    }

    close(): void {
        this.dialogRef.close();
    }

    saveDisabled() {
        return this.originalMemoNote === this.memo;
    }

}
